import React from 'react'
import { Link } from 'gatsby'
import { Stack, Row, Col } from 'react-bootstrap'

import './order_list.scss'

const OrderSummaryListItem = ({ attributes }) => {
  const { title, total_price, quantity, image } = attributes

  return (
    <Row className="order-summary-item mb-4">
      <Col sm={4} className="d-flex justify-content-center align-items-center">
        <OrderSummaryListItemImage url={image} />
      </Col>
      <Col sm={8}>
        <h5 className="title">
          {title}
        </h5>
        <Row className="mt-3">
          <Col xs={6}>
            <h6 className="price">
              {total_price.formatted}
            </h6>
          </Col>
          <Col xs={6}>
            <h6 className="quantity">
              <span>Unit:</span> {quantity}
            </h6>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

const OrderSummaryList = ({ order_items }) => {
  return (
    <Stack direction='vertical' gap={2}>
      {order_items.map((item, index) => {
        return <OrderSummaryListItem key={index} {...item} />
      })}
    </Stack>
  )
}

const OrderSummaryListItemImage = ({ url }) => {
  if (!url) {
    return <></>
  }

  return (
    <div className="product-image">
      <img src={url} width="90px" height="90px" />
    </div>
  )
}

export const getShippingAdjustmentAmount = ({ adjustments }) => {
  const [result] = adjustments.filter(value => value.type === 'shipping')
  return result ? result.total : false
}

export const getTaxAdjustmentAmount = ({ adjustments }) => {
  const [result] = adjustments.filter(value => value.type === 'tax')
  return result ? result.total : false
}

export const OrderSummary = ({ cart }) => {
  const { attributes, relationships } = cart
  const { order_items } = relationships
  const { order_total } = attributes

  const shipping = getShippingAdjustmentAmount(order_total)
  const tax = getTaxAdjustmentAmount(order_total)

  return (
    <div className="order-summary-container">
      <Link to="/products/all" className="button continue-shopping-link">
        Continue Shopping
      </Link>
      <Stack direction='horizontal' gap={2} className="d-flex justify-content-between mt-4 mb-4">
        <div className="title-container">
          <h3 className="title">Your Order</h3>
        </div>
        <Link to="/cart" className="button view-cart-link">View Cart</Link>
      </Stack>
      <OrderSummaryList order_items={order_items.data} />
      <Stack className="total-container mt-2" direction='vertical' gap={2}>
        <label className="sub-total total">
          Sub total: {order_total.subtotal.formatted}
        </label>
        {shipping && shipping.number !== '0.00' && (
          <label className="delivery-total total">
            Delivery: {shipping.formatted}
          </label>
        )}
        <label className="total-total total">
          Total: {order_total.total.formatted}
        </label>
        {tax && (
          <label className="gst-total total">
            Includes {tax.formatted} GST
          </label>
        )}
      </Stack>
      <div className="tos-summary mt-4">
        <p><strong>All prices unless stated are inclusive of GST.</strong></p>
        <p>Prices may vary and are subject to change without notice. 
        Some products not available in Western Australia or Northern Territory. 
        Delivery for large items available to select postcodes only. 
        For delivery orders, the delivery costs will be calculated at checkout. 
        Terms and Conditions apply.</p>
      </div>
    </div>
  )
}

export default OrderSummary